export default "/assets/images/logo.b60848e51dc26ae2.svg";